module.exports = __webpack_public_path__ + "static/media/1019834.7ee0f296.jpg";